import React from "react";
import Search from "./pages/Search";
import Header from "./components/Header";
import { Box } from "@mui/material";

function App() {
  return (
    <>
      <Header />
      <Box sx={{ mt: '-80px'}}>
        <Search />
      </Box>
    </>
  );
}

export default App;
